import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { Box, useTheme } from '@mui/material';

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
  /** En sidebars oscuros: scrollbar más visible (clara) */
  dark?: boolean;
}

const Scrollbar: FC<ScrollbarProps> = ({ className, children, dark, ...rest }) => {
  const theme = useTheme();
  const thumbBg = dark ? theme.colors?.alpha?.trueWhite?.[20] ?? 'rgba(255,255,255,0.2)' : theme.colors.alpha.black[10];
  const thumbHover = dark ? theme.colors?.alpha?.trueWhite?.[40] ?? 'rgba(255,255,255,0.4)' : theme.colors.alpha.black[30];

  return (
    <Scrollbars
      autoHide
      renderThumbVertical={() => (
        <Box
          sx={{
            width: 6,
            minHeight: 40,
            background: thumbBg,
            borderRadius: 3,
            transition: theme.transitions.create(['background']),
            '&:hover': { background: thumbHover }
          }}
        />
      )}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

Scrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dark: PropTypes.bool
};

export default Scrollbar;
